<template>
  <div class="columns is-multiline is-mobile">
    <div class="column is-full">
      <window title="
        <strong style='font-size: 1.5rem'>
          Use UPPERCUT Vue.js theme now to finish complex admin panels in no time
        </strong>">
        <div class="columns is-vcentered is-multiline">
          <div class="column">
            It packs a powerful punch of features to help you cut a
            lot of development time for a wide range of admin panels:
            SaaS Apps, E-commerce Platforms, Blogs, Presentation Websites.
            <br/> <br/> And it's 100% written in the most beautiful VUE.JS code you'd ever see.
          </div>
        </div>
      </window>
    </div>
    <div class="column is-half-desktop is-full-touch">
      <window title="<strong>Your productivity will sky-rocket</strong>">
        <productivity></productivity>
      </window>
    </div>
    <div class="column is-half-desktop is-full-touch">
     <window height="100%" title="<strong>We offer 5-star support</strong>">
        <comments :comments="comments"></comments>
      </window>
    </div>
    <div class="column is-half-desktop is-full-touch">
      <window title="<strong>It has all the right components</strong>">
        <list maxHeight="450px" :items="items"></list>
      </window>
    </div>
    <div class="column is-half-desktop is-full-touch">
       <window title="<strong>Geographical statistics</strong>">
        <geo-chart></geo-chart>
      </window>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import data from '@/assets/data/data.json';
import Productivity from '@/components/pages/charts/Productivity';
import List from '@/components/widgets/List.vue';
import Comments from '@/components/widgets/Comments.vue';
import VueCharts from 'vue-charts/dist/vue-charts';
import GeoChart from './charts/GeoChart.vue';

Vue.use(VueCharts);

export default {
  components: {
    Productivity, List, Comments, GeoChart,
  },
  data() {
    return {
      items: [
        'Buttons',
        'Typography',
        'Helpers',
        'Galleries',
        'Widgets',
        // 'File Uploads',
        'Grids',
        'Form Elements',
        'Misc',
        'App views',
        'Charts',
        'Tables',
        'Animations',
      ],
      comments: data.comments,
    };
  },
};
</script>
